export type LearningXp = {
  totalXp: number;
  earnedXp?: number;
  source?: string | null;
};

export const EMPTY_XP: LearningXp = {
  totalXp: 0,
  earnedXp: 0,
  source: null,
};

export const XP_REWARDS = {
  lesson: 10,
  lesson_step: 1,
  flashcard: 5,
  question_bank: 5,
  question_correct: 1,
} as const;

export type XpSource = keyof typeof XP_REWARDS;
